import React from 'react';

import s from './HeaderPanelActions.css';


const HeaderPanelActions = ({ backButton, backButtonClickHandler, title, children, }) => {

  return (
    <section className={s.component}>
      {backButton &&
        <button
          id="headerBackButton"
          title="Go Back"
          className={s.backButton}
          onClick={() => backButtonClickHandler()}
        />
      }
      {title &&
        <h1 className={s.title}>{title}</h1>
      }
      {children}
    </section>
  );
};

export default HeaderPanelActions;



// WEBPACK FOOTER //
// ./src/components/HeaderBar/HeaderPanelActions.js